import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const CurrentNews = () => {
  const { id } = useParams(); // Obtém o ID da URL
  const [news, setNews] = useState(null); // Estado para armazenar a notícia atual
  const navigate = useNavigate(); // Para navegação de volta ou entre páginas

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch("/assets/json/news.json");

        if (!response.ok) {
          throw new Error(`Erro na requisição: ${response.statusText}`);
        }

        const data = await response.json();

        // Verifica se o JSON contém a propriedade "news" como array
        if (data.news && Array.isArray(data.news)) {
          const selectedNews = data.news.find(
            (item) => item.ID === parseInt(id),
          );
          if (selectedNews) {
            setNews(selectedNews);
          } else {
            console.error("Notícia não encontrada");
          }
        } else {
          throw new Error(
            "O JSON não contém um array válido na propriedade 'news'.",
          );
        }
      } catch (error) {
        console.error("Erro ao carregar o JSON:", error);
      }
    };

    fetchNews();
  }, [id]);

  const showPostDate = (postDate) => {
    const year = postDate.substring(0, 4);
    const month = postDate.substring(5, 7) - 1;
    const day = postDate.substring(8, 10);
    return new Date(year, month, day).toLocaleDateString("pt-BR");
  }

  // Verifica se a notícia está carregada
  if (!news) {
    return <p>Carregando notícia...</p>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg mt-10">
      {/* Botão de voltar */}
      <button
        onClick={() => navigate("/noticias")}
        className="mb-6 text-blue-500 hover:underline"
      >
        &larr; Voltar para Notícias
      </button>

      {/* Detalhes da notícia */}
      <h1 className="text-3xl font-bold text-gray-800 mb-4">{news.title}</h1>
      <p className="text-gray-500 text-sm mb-4">
        {showPostDate(news.postDate)} |{" "}
        {news.category.name || "Sem Categoria"}
      </p>
      <img
        src={news.file.url}
        alt={news.title}
        className="w-full h-120 object-cover rounded-md mb-6"
      />
      <p className="text-gray-700 text-lg leading-relaxed" dangerouslySetInnerHTML={{ __html: news.content }} />
    </div>
  );
};

export default CurrentNews;
